module.exports = __webpack_public_path__ + "static/media/Vicki.32a529e6.jpeg";